let _handler = null;

export const notificationService = {
  setHandler: (fn) => {
    _handler = fn;
  },
  show: (message, status) => {
    _handler?.(message, status);
  },
};
